var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
import { TabController } from './tabController';
let TabPanel = class TabPanel extends BaseComponent {
    firstUpdated() {
        this.tabController = new TabController(this, this.key);
        this.requestUpdate();
    }
    render() {
        if (!this.tabController)
            return nothing;
        if (this.tabController.activeTab !== this.index)
            return nothing;
        return html `
        <slot></slot>
    `;
    }
};
__decorate([
    property()
], TabPanel.prototype, "key", void 0);
__decorate([
    property({ type: Number })
], TabPanel.prototype, "index", void 0);
TabPanel = __decorate([
    customElement('trust-tab-panel')
], TabPanel);
export { TabPanel };
//# sourceMappingURL=tabPanel.js.map